import * as initializers0 from '../initializers/input_components/datepicker.js'; import * as initializers1 from '../initializers/input_components/tooltips.js'; let initializers = [initializers0, initializers1];

let CocoonLoader = function() {
  $('body').on('cocoon:after-insert', (e, item) => {
    if (initializers == undefined) { return };

    initializers.forEach((initializer) => {
      return initializer.default(this);
    });
  })
};

export default CocoonLoader;
